const edges = (pos, size) => [pos, pos + size / 2, pos + size];

function axis(pos, size, targets, th) {
  let best = null;
  edges(pos, size).forEach((c, i) => {
    targets.forEach((t) => {
      const d = Math.abs(c - t);
      if (d <= th && (!best || d < best.d)) best = { d, pos: t - (i * size) / 2, line: t };
    });
  });
  return best;
}

// Returns snapped x/y (mm) and guide lines for an element being dragged.
export function computeSnap(el, x, y, others, tpl, th) {
  const vT = [0, tpl.width / 2, tpl.width, ...others.flatMap((o) => edges(o.x, o.w))];
  const hT = [0, tpl.height / 2, tpl.height, ...others.flatMap((o) => edges(o.y, o.h))];
  const sx = axis(x, el.w, vT, th);
  const sy = axis(y, el.h, hT, th);
  const lines = [];
  if (sx) lines.push({ type: "v", pos: sx.line });
  if (sy) lines.push({ type: "h", pos: sy.line });
  const r2 = (n) => Math.round(n * 100) / 100;
  return { x: r2(sx ? sx.pos : x), y: r2(sy ? sy.pos : y), lines };
}
